@if (data?.error; as error) {
	<div class="form-message-text error">
		@if (errorObject; as errorObj) {
			@if (errorObj.error; as innerError) {
				@if (innerError.message) {
					Error: {{innerError.message}}
				} @else {
					{{innerError.toString()}}
				}
			} @else {
				{{error.toString()}}
			}
		} @else {
			{{error.toString()}}
		}
		<button mat-button (click)="dismiss()" class="dismiss-button" i18n>Cerrar</button>
	</div>
}
@if (data?.response; as response) {
	<div class="form-message-text center">
		{{response.toString()}}
	</div>
}
